import { CONFIGURATION, CUSTOMER } from 'src/api/CoreApi'
import { filtersToUrl } from 'src/utils/filters'

export default function redirectToOtherEntity(
    from,
    to,
    props,
    extraFilters = null
) {
    const { data, history } = props
    let filters = {}
    if (from === CUSTOMER) {
        filters = {
            [`${CUSTOMER}__name`]: [data.name],
        }
    } else if (from === CONFIGURATION) {
        filters = {
            [`${CUSTOMER}__name`]: [data.customer_name],
            [`${CONFIGURATION}__name`]: [data.name],
        }
    }
    if (extraFilters) {
        filters = { ...filters, ...extraFilters }
    }

    let toUrl = `/explorer/${to === CONFIGURATION ? 'configuration' : 'device'}`
    return history.push({
        pathname: toUrl,
        search: filtersToUrl(filters),
    })
}
